import { getSkuConfig, getRealPriceReq } from './api';
import { util, language, CustomException } from '@tencent/ppd-base-libs';

/**
 * @method skuOriginData
 * @description 获取sku配置数据
 * @return {Object}
 */
async function skuOriginData() {
  const [error, result] = await util.to(getSkuConfig());
  if (error) {
    throw new CustomException(
      error,
      'skuConfigLoadFailed',
      'sku config loaded failed',
    );
  }
  return result;
}

/**
 * @method getLangPrefix
 * @description 获取当前语言前缀
 * @return {String} 语言前缀字符串
 */
function getLangPrefix() {
  let prefix = '';
  const lang = language.getLanguage();
  const langMap = {
    'zh-cn': 'cn',
    'zh-hk': 'hk',
    en: 'en',
  };
  const langs = Object.keys(langMap);
  if (langs.indexOf(lang) < 0) {
    prefix = 'en';
  } else {
    prefix = langMap[lang];
  }
  return prefix;
}

/**
 * @method getRealPrice
 * @description 获取最新价格列表
 * @return {Array}
 */
async function getRealPrice(dataType: string) {
  const [err, result] = await util.to(getRealPriceReq(dataType));
  if (err) {
    throw new CustomException(err, 'updatePriceFailed', 'update price failed');
  }
  return result.configList;
}

/**
 * @method  getCurrentLangData
 * @description 获取当前语言环境下的数据
 * @return {Object} result
 */

export async function getCurrentLangData(moduleName: string) {
  // 获取语言数据
  const prefix = getLangPrefix();
  // 获取sku原数据
  const originData = await skuOriginData();
  // let curModuleData = originData.modules.find(item=>item.moduleName==moduleName);
  let output: any = {};
  output = originData.modules.find(item => item.moduleName == moduleName);
  if (!output) return output;
  // 获取当前语言下的 sku模块通用数据（标题\描述\价格数据更新类型）
  output.title = output[`${prefix}Title`];
  output.subTitle = output[`${prefix}SubTitle`];
  output.entranceText = output[`${prefix}EntranceText`];
  output.changeText = output[`${prefix}ChangeText`];

  // 获取最新价格列表
  const [err, realPriceList] = await util.to(getRealPrice('6')); // 统一使用频道及时价格

  // 获取当前语言下的 sku列表数据
  if (output.products && JSON.parse(output.products).data) {
    const dataArr = JSON.parse(output.products).data;
    const temp: any = [];
    for (let i = 0; i < dataArr.length; i++) {
      let child: any = {};
      child = originData.products.find(v => v.id == dataArr[i]);
      if (child) temp.push(child);
    }
    if (realPriceList) {
      temp.forEach((item: any) => {
        item.title = item[`${prefix}Name`];
        item.titleShort = item[`${prefix}NameShort`];
        item.imgUrl = item[`${prefix}ImgUrl`]
          || item.hkImgUrl
          || item.enImgUrl
          || item.cnImgUrl;
        const product = realPriceList.find(prod => prod.id == item.id);
        if (!product) return;
        // 合并接口最新价格
        if (product.originPrice) item.oldPrice = `${product.originPrice}`;
        if (product.curPrice) item.newPrice = `${product.curPrice}`;
        if (product.expireTime) item.deadline = product.expireTime;
        if (product.soldOut && '0' != item.useEndSoldout) {
          item.soldOut = product.soldOut;
        }
      });
    }
    output.products = temp;
  }
  if (output.banners && JSON.parse(output.banners).data) {
    const dataArr = JSON.parse(output.banners).data;
    const temp: any = [];
    for (let i = 0; i < dataArr.length; i++) {
      let child: any = {};
      child = originData.banners.find(v => v.id == dataArr[i]);
      child.imgUrl = child[`${prefix}ImgUrl`]
        || child.hkImgUrl
        || child.enImgUrl
        || child.cnImgUrl;
      if (child) temp.push(child);
    }
    output.banners = temp;
  }
  // 当前语言下所需数据
  return output;
}
